import { useEffect, useMemo, useState } from "react";

import intl from "react-intl-universal";

import { ValutDialog } from "../../../../../Components/Molecules/ValutDialog";

import {

  countrySuggestsCpf,

  getDeclarationPickerId,

  getPersonUploadTypesForCountry,

  IDENTITY_VARIANT,

} from "../baasIdentitySchemes";

import { formatDocumentTypeLabel } from "../baasEntidadeDocumentUtils";

import { IDENTITY_DOC_LABEL_VARIANT } from "../baasIdentityDocumentLabels";

import { CountrySelectField } from "./baasEntidadeCreateFields";



export const BaasEntidadeNewDocumentModal = ({

  open,

  onClose,

  countryOptions = [],

  existingPickerIds = [],

  onConfirm,

}) => {

  const [countryCode, setCountryCode] = useState("");

  const [pickerId, setPickerId] = useState("");



  useEffect(() => {

    if (!open) {

      setCountryCode("");

      setPickerId("");

    }

  }, [open]);



  useEffect(() => {

    setPickerId("");

  }, [countryCode]);



  const typeOptions = useMemo(

    () => getPersonUploadTypesForCountry(countryCode),

    [countryCode],

  );



  const availableTypes = useMemo(

    () => typeOptions.filter((option) => {

      const optionPickerId = getDeclarationPickerId(option.value, option.identityVariant);

      return !existingPickerIds.includes(optionPickerId) && !existingPickerIds.includes(option.value);

    }),

    [typeOptions, existingPickerIds],

  );



  const handleConfirm = () => {

    if (!countryCode || !pickerId) return;

    const selected = availableTypes.find(

      (option) => getDeclarationPickerId(option.value, option.identityVariant) === pickerId,

    );

    if (!selected) return;

    onConfirm?.({

      countryCode,

      documentType: selected.value,

      identityVariant: selected.identityVariant || null,

    });

    onClose?.();

  };



  const resolveDriversLicenseVariant = (option) => {

    if (option.value !== "DRIVERS_LICENSE") {

      return IDENTITY_DOC_LABEL_VARIANT.DEFAULT;

    }

    if (option.identityVariant === IDENTITY_VARIANT.CPF) {

      return IDENTITY_DOC_LABEL_VARIANT.CPF_PROOF;

    }

    return IDENTITY_DOC_LABEL_VARIANT.STANDALONE;

  };



  return (

    <ValutDialog

      open={open}

      onClose={onClose}

      title={intl.get("baas.entidades.detail.declararNovoDocumento")}

      maxWidth="sm"

      footer={

        <>

          <button type="button" className="btn-outline w-full sm:w-auto" onClick={onClose}>

            {intl.get("common.cancel")}

          </button>

          <button

            type="button"

            className="btn-primary w-full sm:w-auto"

            disabled={!countryCode || !pickerId}

            onClick={handleConfirm}

          >

            {intl.get("baas.entidades.detail.declararNovoDocumentoConfirm")}

          </button>

        </>

      }

    >

      <p className="text-sm text-gray-600 dark:text-gray-300">

        {intl.get("baas.entidades.detail.declararNovoDocumentoHint")}

      </p>

      <div className="mt-4 space-y-3">

        <CountrySelectField

          label={intl.get("baas.entidades.detail.uploadCountryLabel")}

          value={countryCode}

          onChange={setCountryCode}

          countryOptions={countryOptions}

          required

        />

        {countrySuggestsCpf(countryCode) ? (

          <p className="text-xs text-gray-500 dark:text-gray-400">

            {intl.get("baas.entidades.detail.documentsSuggestCpfBr")}

          </p>

        ) : null}

        <label className="block text-sm">

          <span className="mb-1 block text-gray-600 dark:text-gray-400">

            {intl.get("baas.entidades.detail.documentType")}

          </span>

          <select

            className="h-10 w-full rounded-lg border border-gray-200 px-3 text-sm outline-none focus:border-[#e7a73f] disabled:cursor-not-allowed disabled:opacity-60 dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-100"

            value={pickerId}

            disabled={!countryCode}

            onChange={(event) => setPickerId(event.target.value)}

          >

            {!countryCode ? (

              <option value="">

                {intl.get("baas.entidades.detail.documentsUploadCountryRequired")}

              </option>

            ) : (

              <>

                <option value="">

                  {intl.get("baas.entidades.detail.documentType")}

                </option>

                {availableTypes.map((option) => {

                  const optionPickerId = getDeclarationPickerId(option.value, option.identityVariant);

                  return (

                    <option key={optionPickerId} value={optionPickerId}>

                      {formatDocumentTypeLabel(option.value, {

                        countryCode,

                        countryOptions,

                        identityVariant: option.identityVariant,

                        variant: resolveDriversLicenseVariant(option),

                        labelRole: "declaration",

                      })}

                      {option.required ? ` (${intl.get("baas.entidades.create.required")})` : ""}

                    </option>

                  );

                })}

              </>

            )}

          </select>

        </label>

        {countryCode && availableTypes.length === 0 ? (

          <p className="text-xs text-gray-500 dark:text-gray-400">

            {intl.get("baas.entidades.detail.declararNovoDocumentoAllAdded")}

          </p>

        ) : null}

      </div>

    </ValutDialog>

  );

};



export default BaasEntidadeNewDocumentModal;

